import Swiper, { Thumbs, Navigation, Pagination, Zoom, EffectFade } from "swiper/core"

Swiper.use([Thumbs, Navigation, Pagination, Zoom, EffectFade])

const blogFreeResources = {
  initGallery() {
    if ($(window).width() <= 1024) {
      return new Swiper('.blogFreeResources .resources', {
        slidesPerView: "auto",
        spaceBetween: 16,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          paginationUpdate: function (swiper) {
            console.log(swiper);
            if (swiper.pagination.bullets.length <= 1) {
              document.querySelector('.blogFreeResources .swiper-pagination').classList.add('hidden');
              document.querySelector('.blogFreeResources .swiper-wrapper').classList.add('justify-center');
            } else {
              document.querySelector('.blogFreeResources .swiper-pagination').classList.remove('hidden');
              document.querySelector('.blogFreeResources .swiper-wrapper').classList.remove('justify-center');
            }
          }
        }
      })
    }
  },

  init() {
    this.initGallery()
  }
}

export default blogFreeResources